import { trigger, style, animate, transition, query, stagger, state } from '@angular/animations';

export const flip =  trigger('flip', [   
  state('void => *', style({ transform: 'rotateX(0)', opacity: 1})),     
  transition('void => *', []),
   transition('* => *', [      
     animate(400, style({ transform: 'rotateX(180deg)', opacity: .2 })),
  ])
 ])
